import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0309c229"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accounts card custom-card custom-card-padding" }
const _hoisted_2 = {
  key: 0,
  class: "active"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rafraîchir", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync" })
], -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "notification is-danger is-light"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Une erreur inattendue est survenue pendant le chargement des portefeuilles. Veuillez nous excuser pour le désagrément. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Vous pouvez essayer de recharger la page, ou contacter votre administrateur si l'erreur persiste. ", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "notification is-default"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "custom-card-title" }, "vos comptes", -1))
const _hoisted_13 = {
  key: 1,
  class: "inactive"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "custom-card-title" }, "vos comptes en attente de création", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Acc = _resolveComponent("Acc")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loading, {
      active: _ctx.isLoadingAccounts,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoadingAccounts) = $event)),
      "can-cancel": false,
      "is-full-page": false
    }, null, 8, ["active"]),
    (!_ctx.isLoadingAccounts)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshBalanceAndTransactions && _ctx.refreshBalanceAndTransactions(...args))),
            title: "Rafraîchir le solde et les transactions",
            class: "button is-default is-pulled-right is-rounded refresh"
          }, _hoisted_5),
          (_ctx.hasAccountsLoadingError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
            : (_ctx.totalAccountsLoaded === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Vous n'avez pas encore de compte "))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeVirtualAccounts, (account) => {
                    return (_openBlock(), _createBlock(_component_Acc, {
                      bal: account.bal,
                      curr: account.curr,
                      backend: account.backend,
                      type: account.type,
                      active: account.active,
                      subAccounts: account.subAccounts || []
                    }, {
                      name: _withCtx(() => [
                        _createTextVNode(_toDisplayString(account.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["bal", "curr", "backend", "type", "active", "subAccounts"]))
                  }), 256))
                ]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.inactiveVirtualAccounts.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inactiveVirtualAccounts, (account) => {
            return (_openBlock(), _createBlock(_component_Acc, {
              bal: account.bal,
              curr: account.curr,
              backend: account.backend,
              type: account.type,
              active: account.active
            }, {
              name: _withCtx(() => [
                _createTextVNode(_toDisplayString(account.name), 1)
              ]),
              _: 2
            }, 1032, ["bal", "curr", "backend", "type", "active"]))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}